// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/Master.css
// module id = 2707
// module chunks = 0